module.exports = __webpack_public_path__ + "static/scale-model-of-white-river-state-park-in-indianapolis-indiana-679a7e0e603f4d0bcd35611a94de6564.png";